import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import createBemClass from "react-bem-builder";
import get from "lodash/get";
import { map, find, reverse, slice, isUndefined } from "lodash";
import { Header, Section, Slider, ProjectNavLink } from "../../components";
import { Row, Col } from "../../components/layout";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import { cssTransitionClasses } from "../../transitions/utilities/transition-utility";
import Linkify from "linkify-react";

const headerCn = createBemClass("project-detail-header");
const projectContentSectionCn = createBemClass(
  "project-detail-section-project-content"
);
const projectNavigationSectionCn = createBemClass(
  "project-detail-section-project-navigation"
);

class ProjectDetailContainer extends Component {
  constructor(props) {
    super(props);

    if (!props.project) {
      props.router.push("/our-work");
    }
    this.handleBeeClick = this.handleBeeClick.bind(this);
  }

  state = {
    beeVisible: true
  };

  handleBeeClick() {
    this.setState({ beeVisible: false });
  }

  render() {
    if (!this.props.project) {
      return null;
    }

    return (
      <Fragment>
        {this.renderHeader()}
        <TransitionGroup component={null}>
          <CSSTransition
            key={"project-detail-page-content"}
            classNames={cssTransitionClasses("project-detail-page-content")}
            appear={true}
            timeout={500}
          >
            <div>
              {this.renderProjectContentSection()}{" "}
              {this.renderProjectNavigationSection()}
            </div>
          </CSSTransition>
        </TransitionGroup>
      </Fragment>
    );
  }

  renderHeader() {
    const { beeVisible } = this.state;
    const { project } = this.props;
    const style = project.backgroundImage
      ? {
          background: `url(${project.backgroundImage}) center / cover no-repeat`
        }
      : {
          background: `radial-gradient(ellipse at right bottom, ${project["theme_colours"].light}, ${project["theme_colours"].dark}`
        };
    return (
      <Header className={headerCn()} dark noTopSpacing style={style}>
        <div className={headerCn("content")}>
          <div className={headerCn("title-wrapper")}>
            <div className={headerCn("project-label")}>Project</div>
            <h1 className={headerCn("heading")}>{project.title}</h1>
          </div>
          {get(project, "id") === "bloom-fm" && (
            <Fragment>
              <img
                src={project.bee}
                className={headerCn("bee", beeVisible ? "" : "bee--animate")}
                alt="Bloom-fm bee"
                onClick={this.handleBeeClick}
              />
              <img
                src="/images/projects/flower.svg"
                className={headerCn("flower")}
                alt="Bloom-fm flowers"
              />
            </Fragment>
          )}
          <div className={headerCn("image-wrapper")}>
            <img src={project.hero_image.url} title={project.hero_image.name} />
          </div>
        </div>
      </Header>
    );
  }

  renderProjectContentSection() {
    const { project } = this.props;
    const sliderOptions = {
      dots: true,
      arrows: true,
      infinite: true,
      autoplay: true,
      speed: 300,
      autoplaySpeed: 3000,
      slidesToShow: 1,
      slidesToScroll: 1
    };
    return (
      <Section className={projectContentSectionCn()}>
        <div className={projectContentSectionCn("inner")}>
          <div className={projectContentSectionCn("intro-container")}>
            <Row>
              <Col sm={12} lg={6}>
                <div className={projectContentSectionCn("intro-title")}>
                  <h3>{project.introduction}</h3>
                </div>
              </Col>
              <Col xs={12} lg={6}>
                <Row className={projectContentSectionCn("meta-row")}>
                  {map(project["meta_data"], (meta, index) => (
                    <Col key={index} xs={6}>
                      <div className={projectContentSectionCn("meta-field")}>
                        <span className={projectContentSectionCn("")}>
                          {meta.title}
                        </span>
                        <span
                          className={projectContentSectionCn(
                            "meta-field-value"
                          )}
                        >
                          {meta.value}
                        </span>
                      </div>
                    </Col>
                  ))}
                  {!isUndefined(project.deliverables) && (
                    <Col xs={12}>
                      <div className={projectContentSectionCn("intro-field")}>
                        <span className={projectContentSectionCn("")}>
                          Deliverables
                        </span>
                        <span
                          className={projectContentSectionCn(
                            "intro-field-value"
                          )}
                        >
                          {project.deliverables.map(deliverable => (
                            <p>{deliverable}</p>
                          ))}
                        </span>
                      </div>
                    </Col>
                  )}
                  <Col xs={12}>
                    <div className={projectContentSectionCn("intro-field")}>
                      <span className={projectContentSectionCn("")}>Year</span>
                      <span
                        className={projectContentSectionCn("intro-field-value")}
                      >
                        {project.year}
                      </span>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
          <div className={projectContentSectionCn("description-container")}>
            <Row>
              <Col
                sm={12}
                lg={6}
                className={projectContentSectionCn("description-col")}
              >
                {/* TODO: scale this solution as it only works for the aquisition link */}
                <Linkify
                  as="p"
                  options={{
                    render: {
                      url: ({ attributes }) => (
                        <a {...attributes}>
                          {project.id === "forge-trust"
                            ? "acquired"
                            : "acquisition"}
                        </a>
                      )
                    }
                  }}
                >
                  {project["description_1"]}
                </Linkify>
              </Col>
              <Col
                sm={12}
                lg={6}
                className={projectContentSectionCn("description-col")}
              >
                {/* TODO: scale this solution as it only works for the aquisition link */}
                <Linkify
                  as="p"
                  options={{
                    render: {
                      url: ({ attributes }) => (
                        <a {...attributes}>
                          {project.id === "forge-trust"
                            ? "acquired"
                            : "acquisition"}
                        </a>
                      )
                    }
                  }}
                >
                  {project["description_2"]}
                </Linkify>
              </Col>
            </Row>
          </div>
          <div className={projectContentSectionCn("slider-container")}>
            <Slider {...sliderOptions} modifier={`project-image ${project.id}`}>
              {map(project.images, (image, index) => (
                <img key={index} src={image.url} title={image.name} />
              ))}
            </Slider>
          </div>
          <div className={projectContentSectionCn("meta-container")}>
            <Col sm={12}>
              <div className={projectContentSectionCn("intro-fields")}>
                <Row>
                  <Col sm={8}>
                    <div className={projectContentSectionCn("intro-field")}>
                      <span
                        className={projectContentSectionCn("intro-field-label")}
                      >
                        Services
                      </span>
                      <span
                        className={projectContentSectionCn("intro-field-value")}
                      >
                        {map(project.services, (service, index) => (
                          <span key={index}>
                            {service.name}
                            <br />
                          </span>
                        ))}
                      </span>
                    </div>
                  </Col>
                  <Col sm={4}>
                    <div className={projectContentSectionCn("intro-field")}>
                      <span
                        className={projectContentSectionCn("intro-field-label")}
                      >
                        Platform
                      </span>
                      <span
                        className={projectContentSectionCn("intro-field-value")}
                      >
                        {map(project.platforms, (platform, index) => (
                          <span key={index}>
                            {platform.name}
                            {platform.description ? (
                              <Fragment>
                                <span>:</span>
                                <br />
                                <div style={{ margin: "0 0 0 2rem" }}>
                                  {platform.description}
                                </div>
                              </Fragment>
                            ) : (
                              <br />
                            )}
                          </span>
                        ))}
                      </span>
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
          </div>
        </div>
      </Section>
    );
  }

  renderProjectNavigationSection() {
    const { prevProject, nextProject } = this.props;
    return (
      <Section className={projectNavigationSectionCn()}>
        <Row>
          <Col>
            {prevProject && (
              <div className={projectNavigationSectionCn("link-container")}>
                <span className={projectNavigationSectionCn("link-label")}>
                  Previous project
                </span>
                <ProjectNavLink
                  direction="left"
                  to={"/our-work/" + prevProject.id}
                  title={prevProject.id}
                  className={projectNavigationSectionCn("link")}
                >
                  {prevProject.title}
                </ProjectNavLink>
              </div>
            )}
          </Col>
          <Col>
            {nextProject && (
              <div
                className={projectNavigationSectionCn(
                  "link-container",
                  "link-container--right"
                )}
              >
                <span className={projectNavigationSectionCn("link-label")}>
                  Next project
                </span>
                <ProjectNavLink
                  direction="right"
                  to={"/our-work/" + nextProject.id}
                  title={nextProject.id}
                  className={projectNavigationSectionCn("link")}
                >
                  {nextProject.title}
                </ProjectNavLink>
              </div>
            )}
          </Col>
        </Row>
      </Section>
    );
  }
}

const mapStateToProps = (state, props) => {
  const projectId = props.match.params.projectId;
  const reversedProjects = reverse(slice(state.externalProjects));
  const projectIds = map(reversedProjects, "id");

  if (projectIds.indexOf(projectId) !== -1) {
    const currentIndex = projectIds.indexOf(projectId);
    return {
      project: reversedProjects[currentIndex],
      prevProject:
        reversedProjects[
          currentIndex === 0 ? reversedProjects.length - 1 : currentIndex - 1
        ],
      nextProject:
        reversedProjects[
          currentIndex + 1 === reversedProjects.length ? 0 : currentIndex + 1
        ]
    };
  } else {
    return null;
  }
};

export default connect(mapStateToProps)(ProjectDetailContainer);
